"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConnection = exports.isConnectionConnecting = void 0;
var signalr_1 = require("@microsoft/signalr");
function isConnectionConnecting(connection) {
  return connection.state === signalr_1.HubConnectionState.Connected || connection.state === signalr_1.HubConnectionState.Reconnecting || connection.state === signalr_1.HubConnectionState.Connecting;
}
exports.isConnectionConnecting = isConnectionConnecting;
function createConnection(url, transportType) {
  var automaticReconnect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var connectionBuilder = new signalr_1.HubConnectionBuilder().withUrl(url, transportType);
  if (automaticReconnect) {
    if (Array.isArray(automaticReconnect)) {
      connectionBuilder = connectionBuilder.withAutomaticReconnect(automaticReconnect);
    } else {
      connectionBuilder = connectionBuilder.withAutomaticReconnect();
    }
  }
  if (transportType.logger) {
    connectionBuilder = connectionBuilder.configureLogging(transportType.logger);
  }
  var connection = connectionBuilder.build();
  return connection;
}
exports.createConnection = createConnection;